import copyLink from '../icons/copyLink.svg';
import email from '../icons/email.svg';
import facebook from '../icons/facebook.svg';
import messenger from '../icons/messenger.svg';
import sms from '../icons/sms.svg';
import twitter from '../icons/twitter.svg';
import vk from '../icons/vk.svg';
import weibo from '../icons/weibo.svg';
import whatsapp from '../icons/whatsapp.svg';

const channelInfo = {
  TWITTER: {
    name: 'twitter',
    icon: twitter,
    restrict: true,
  },
  FACEBOOK: {
    name: 'facebook',
    icon: facebook,
    restrict: true,
  },
  MESSENGER: {
    name: 'messenger',
    icon: messenger,
  },
  EMAIL: {
    name: 'email',
    icon: email,
  },
  VK: {
    name: 'vk',
    icon: vk,
  },
  WEIBO: {
    name: 'weibo',
    icon: weibo,
  },
  WHATSAPP: {
    name: 'whatsapp',
    icon: whatsapp,
    mobileOnly: true,
  },
  SMS: {
    name: 'sms',
    icon: sms,
    mobileOnly: true,
  },
  COPY_LINK: {
    name: 'copyLink',
    icon: copyLink,
  },
};

const getChannelInfo = channel => (
  channelInfo[channel]
);

export default getChannelInfo;
